import { View, XStack } from 'tamagui'

interface IQuestionWrapperProps {
  color: string
  children: React.ReactNode
}

export function QuestionWrapper({ children, color }: IQuestionWrapperProps) {
  return (
    <XStack alignItems="center" mb="$spacing-inset-nano">
      <View
        backgroundColor={color}
        borderWidth={1}
        borderRightWidth={0}
        borderColor="$neutral-200"
        width={8}
        height={'100%'}
        borderTopLeftRadius="$border-radius-sm"
        borderBottomLeftRadius="$border-radius-sm"
      />
      <XStack
        borderWidth={1}
        borderLeftWidth={0}
        borderColor="$neutral-200"
        borderTopRightRadius="$border-radius-sm"
        borderBottomRightRadius="$border-radius-sm"
        flex={1}
        pl="$spacing-inset-nano"
      >
        {children}
      </XStack>
    </XStack>
  )
}
